import { MessageStoreOptions } from '@/types/components';

export const getInitMessageStoreOptions = (): MessageStoreOptions => {
  return {
    isUsingDetectedLanguage: false,
  };
};
